import { render } from "./readMore.vue?vue&type=template&id=2a4d394c"
import script from "./readMore.vue?vue&type=script&lang=js"
export * from "./readMore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__